import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";
import forEach from "lodash/forEach";
import head from "lodash/head";
import isNil from "lodash/isNil";
import findGroupNode from "../nodeOrEdgeSourceDataHandling/findGroupNode";
import addOrUpdateGroupNodesLabel from "../nodeRendering/addOrUpdateGroupNodesLabel";
export default (graphComponentRef, groupId, nodesSource, updateLabel = true) => {
    var _a, _b, _c, _d;
    const mainNodeId = (_a = head(nodesSource)) === null || _a === void 0 ? void 0 : _a.NodeId;
    if (!mainNodeId || !((_b = graphComponentRef.current) === null || _b === void 0 ? void 0 : _b.graph))
        return undefined;
    const group = findGroupNode(graphComponentRef, groupId);
    if (!group || !((_c = group.tag) === null || _c === void 0 ? void 0 : _c.GroupId) || !((_d = group.tag) === null || _d === void 0 ? void 0 : _d.Nodes))
        return undefined;
    const resultTag = cloneDeep(group.tag);
    forEach(nodesSource, nodeSource => {
        const isNodeSource = Boolean(nodeSource.DocumentObjectId);
        const nodeTagIndex = resultTag.Nodes.findIndex((e) => e.NodeId === nodeSource.NodeId);
        if (nodeTagIndex === -1) {
            if (isNodeSource) {
                resultTag.Nodes.unshift(nodeSource);
                resultTag.GroupObjectCount = (resultTag.GroupObjectCount || 0) + 1;
            }
            return;
        }
        if (isNodeSource) {
            resultTag.Nodes[nodeTagIndex] = nodeSource;
        }
        else {
            if (!resultTag.Nodes[nodeTagIndex].AttributeValues)
                resultTag.Nodes[nodeTagIndex].AttributeValues = [];
            if (nodeSource.AttributeValues) {
                forEach(nodeSource.AttributeValues, attr => {
                    var _a, _b;
                    const prevIndex = findIndex(resultTag.Nodes[nodeTagIndex].AttributeValues, [
                        "Key",
                        attr.Key
                    ]);
                    if (prevIndex === -1) {
                        if (!isNil(attr.Value))
                            (_a = resultTag.Nodes[nodeTagIndex].AttributeValues) === null || _a === void 0 ? void 0 : _a.push({
                                Key: attr.Key,
                                Value: attr.Value
                            });
                    }
                    else if (isNil(attr.Value))
                        (_b = resultTag.Nodes[nodeTagIndex].AttributeValues) === null || _b === void 0 ? void 0 : _b.splice(prevIndex, 1);
                    else if (resultTag.Nodes[nodeTagIndex].AttributeValues[prevIndex])
                        resultTag.Nodes[nodeTagIndex].AttributeValues[prevIndex].Value =
                            attr.Value;
                });
            }
            else {
                resultTag.Nodes[nodeTagIndex] = {
                    ...resultTag.Nodes[nodeTagIndex],
                    ...nodeSource
                };
            }
        }
    });
    group.tag = resultTag;
    updateLabel && addOrUpdateGroupNodesLabel(graphComponentRef, group);
    return { group };
};
